<template>
	<div class="h5 text-center">
		<i
			class="fas fa-fast-backward pointer"
			@click.prevent="change('start')"
			:class="page <= 1 ? 'disabled': ''"
		></i>
		<i
			class="fas fa-chevron-left pl-2 pointer"
			@click.prevent="change(-1)"
			:class="page <= 1 ? 'disabled': ''"
		></i>
		<span class="pl-1 pr-1">
			[ {{ page }} / {{ totalPages }} ]
		</span>
		<i
			class="fas fa-chevron-right pr-2 pointer"
			@click.prevent="change(1)"
			:class="page >= totalPages ? 'disabled': ''"
		></i>
		<i
			class="fas fa-fast-forward pointer"
			@click.prevent="change('end')"
			:class="page >= totalPages ? 'disabled': ''"
		></i>
	</div>
</template>
<script type="text/javascript">
export default {
	props: ['total'],

	methods: {
		change(x) {
			let from = ~~this.$route.query.from || 0
			switch (x) {
				case 'start': from = 0
					break
				case 'end': from = this.totalPages-1
					break
				default: from += ~~x
					break
			}
			let query = Object.assign({}, this.$route.query)
			query.from = from
			this.$router.push({ query })
    	}
	},

	computed: {	
		page() {
			return ~~this.$route.query.from+1
		},
		
		totalPages() {
			var division = Math.floor(this.total / this.limit)
			if(this.total == 0) {
				return 1
			} else {
				return ~~division + (division * this.limit < this.total ? 1 : 0)
			}
    	}
	},
	
}
</script>



// WEBPACK FOOTER //
// src/components/paginate.vue